import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthModel } from '../Models/AuthModel';
import { LoginModel } from '../Models/LoginModel';
import { ForgetPasswordModel } from '../Models/forget-password-model';
import { ResetPasswordModel } from '../Models/reset-password-model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private http: HttpClient) { }
  lang: string;
  public setLang(lng: string) {
    this.lang = lng;
  }

  login(loginModel: LoginModel): Observable<AuthModel> {
    let url: string = environment.apiBaseUrl + "api/Authentication/Login";

    if (!this.lang)
      this.lang = 'en';

    return this.http.post<AuthModel>(url, loginModel, {
      headers: {
        'lang': this.lang
      }
    });
  }

  saveAurhDate(model: AuthModel) {
    localStorage.setItem("token", JSON.stringify(model))
  }

  private parseAuthSafe(): AuthModel | null {
    const raw = localStorage.getItem("token");
    if (!raw) return null;
    try {
      const obj = JSON.parse(raw) as AuthModel;
      return obj;
    } catch {
      return null;
    }
  }

  /** Returns the bearer token string whether stored as JSON AuthModel or raw JWT */
  getTokenValue(): string {
    const raw = localStorage.getItem("token");
    if (!raw) return "";
    try {
      const obj = JSON.parse(raw) as any;
      return obj && obj.token ? obj.token : raw;
    } catch {
      return raw;
    }
  }

  isAuthenticated(): boolean {
    const auth = this.parseAuthSafe();
    if (auth) {
      if (auth.expireOn <= new Date()) {
        this.logOut();
        return false;
      }
      return true;
    }
    // Fallback: treat presence of raw token as authenticated
    const token = this.getTokenValue();
    return !!token;
  }

  isVerified(): boolean {
    const auth = this.parseAuthSafe();
    if (!auth) return true; // assume verified when only raw token exists
    if (!auth.isVerified && auth.userType == 2)
      return false;
    else
      return true;
  }

  getAuthDate(): AuthModel | null {
    return this.parseAuthSafe();
  }

  logOut() {
    localStorage.removeItem("token");
  }

  authKeyExists(key: string): boolean {
    const auth = this.parseAuthSafe();
    if (!auth || !auth["permission"]) return false;
    const permissions = auth["permission"] as string[];
    return Array.isArray(permissions) ? permissions.includes(key) : false;
  }


  forgotPassword(model: ForgetPasswordModel): Observable<any> {
    let url: string = environment.apiBaseUrl + "api/Authentication/ForgotPassword";
    return this.http.post(url, model);
  }

  resetPassword(model: ResetPasswordModel): Observable<any> {
    let url: string = environment.apiBaseUrl + "api/Authentication/ResetPassword";
    return this.http.post(url, model);
  }


}
